import React from "react";

const YouTubeVideoModal = ({ url, closeModal }) => {
     const handleOutsideClick = (e) => {
    if (e.target.classList.contains("custom-modal-overlay")) {
      closeModal();
    }
  };
  return (
    <div
      className="modal fade show "
      tabIndex="-1"
      style={{
        display: "block",
        background: "rgba(0, 0, 0, 0.5)", // Add overlay effect
      }}
      aria-labelledby="exampleModalLabel"
      aria-hidden="false"
     
    >
      <div className="d-flex justify-content-center align-items-center vh-100 custom-modal-overlay"  onClick={handleOutsideClick}>
        <div
          className="modal-content p-3 youtube-modal"
          style={{ width: "1000px" }}
        >
          <div className="modal-body position-relative">
            {/* Close Button */}
            {/* <button
              type="button"
              className="btn-close-iframe position-absolute top-0 end-0 m-2"
              onClick={closeModal}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button> */}

            {/* Video Player */}
            {url ? (
              <iframe
                src={`${url}&autoplay=1`}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="YouTube Video"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "12px",
                }}
              />
            ) : (
              <p className="text-center">No video available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeVideoModal;
